export default __webpack_public_path__ + "static/media/Group_898.d46ebfd3.png";